import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import '../styles/Booking.css';

function Booking() {
  const form = useRef();
  const [status, setStatus] = useState('');

  const sendBooking = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_vq9ia2e',
        'template_kc1l1le',
        form.current,
        'IDq7Z1U0JNXfmiw9a'
      )
      .then(
        () => {
          setStatus('success');
          form.current.reset();
        },
        () => {
          setStatus('error');
        }
      );
  };

  return (
    <section className="booking" id="booking">
      <div className="section-header">
        <div className="section-tag">Schedule a visit</div>
        <h2 className="section-title">Book an Appointment</h2>
        <p className="section-sub">Send us your preferred date and time — we'll confirm within 24 hours.</p>
      </div>

      <form className="booking-form" ref={form} onSubmit={sendBooking}>
        <div className="form-row">
          <div className="form-group">
            <label>First name</label>
            <input type="text" name="first_name" placeholder="Jane" required />
          </div>
          <div className="form-group">
            <label>Last name</label>
            <input type="text" name="last_name" placeholder="Doe" required />
          </div>
        </div>

        <div className="form-group">
          <label>Email address</label>
          <input type="email" name="email" placeholder="jane@email.com" required />
        </div>

        <div className="form-group">
          <label>Phone number</label>
          <input type="tel" name="phone" placeholder="(403) 555-0000" required />
        </div>

        <div className="form-group">
          <label>Select service</label>
          <select name="service" required>
            <option value="">Choose a service...</option>
            <option>Custom Facial (60 min) — $80</option>
            <option>Dermaplaning — $50</option>
            <option>Dermaplaning + Jelly Mask — $60</option>
            <option>Microneedling — $150</option>
            <option>Lash Lift — $40</option>
            <option>Waxing — Lip ($10)</option>
            <option>Waxing — Chin ($10)</option>
            <option>Waxing — Underarms ($20)</option>
            <option>Waxing — Half Arms ($30)</option>
            <option>Waxing — Full Arms ($40)</option>
            <option>Waxing — Half Legs ($40)</option>
            <option>Waxing — Full Legs ($60)</option>
            <option>Waxing — Bikini ($30)</option>
            <option>Waxing — Extended Bikini ($40)</option>
            <option>Waxing — Brazilian ($60)</option>
            <option>Waxing — Chest ($45)</option>
            <option>Waxing — Back ($50)</option>
          </select>
        </div>

        <div className="form-group">
          <label>Preferred date</label>
          <input type="date" name="appt_date" required />
        </div>

        <div className="form-group">
          <label>Preferred time</label>
          <input type="text" name="time_slot" placeholder="e.g. mornings, or after 3pm" required />
        </div>

        <div className="form-group">
          <label>Special requests (optional)</label>
          <textarea name="message" placeholder="Any skin concerns or notes for your esthetician..."></textarea>
        </div>

        <button type="submit" className="confirm-btn">Request Appointment</button>

        {status === 'success' && (
          <p className="form-status success">Request sent! We'll confirm your appointment within 24 hours.</p>
        )}
        {status === 'error' && (
          <p className="form-status error">Something went wrong. Please try again.</p>
        )}
      </form>
    </section>
  );
}

export default Booking;